<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de ubicaciones</h1>
    </div>
    <br />
    <div class="card-header">
      <button id="" class="primary-button" appPermision="/location+c" (click)="createLocation()">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncLocations | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let location">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/location+u"
                    (click)="updateLocation(location)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a appOnlysuperuser="/location" (click)="eliminate(location)" class="icon-button">
                    <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let location">
                {{ location.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="countryCode">
              <th mat-header-cell *matHeaderCellDef>Código país</th>
              <td mat-cell *matCellDef="let location">
                {{ location.countryCode }}
              </td>
            </ng-container>

            <ng-container matColumnDef="country">
              <th mat-header-cell *matHeaderCellDef>País</th>
              <td mat-cell *matCellDef="let location">
                {{ location.country }}
              </td>
            </ng-container>

            <ng-container matColumnDef="departmentCode">
              <th mat-header-cell *matHeaderCellDef>Código departamento</th>
              <td mat-cell *matCellDef="let location">
                {{ location.departmentCode }}
              </td>
            </ng-container>
            <ng-container matColumnDef="department">
              <th mat-header-cell *matHeaderCellDef>Departamento</th>
              <td mat-cell *matCellDef="let location">
                {{ location.department }}
              </td>
            </ng-container>
            <ng-container matColumnDef="cityCode">
              <th mat-header-cell *matHeaderCellDef>Código ciudad</th>
              <td mat-cell *matCellDef="let location">
                {{ location.cityCode }}
              </td>
            </ng-container>
            <ng-container matColumnDef="city">
              <th mat-header-cell *matHeaderCellDef>Ciudad</th>
              <td mat-cell *matCellDef="let location">
                {{ location.city }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchLocation($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
